<ds-modal
  #deleteFileModal
  [ds-modal-trigger-for]="deleteFileModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '450px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
  [accentBarTone]="BaseTone.CRITICAL"
>
  <ds-icon icon="bin" size="lg" [tone]="IconTextTone.CRITICAL" />
  <ds-box-header>{{ 'backoffice.deleteFileModal.title' | translate }}</ds-box-header>

  <ds-box-content>
    <ds-label>{{ 'backoffice.deleteFileModal.label' | translate }}</ds-label>
  </ds-box-content>

  <ds-box-footer>
    <button id="btn-vin-close-modal" ds-button variant="outline" class="me-2x" #dsModalDismissElement>
      {{ 'common.buttons.cancel' | translate }}
    </button>
    <button
      id="btn-delete-vin"
      ds-button
      ds-loading
      [isLoading]="isDeletingFile()"
      icon="bin"
      [variant]="ButtonTone.DESTRUCTIVE"
      (click)="deleteFile()"
    >
      {{ 'backoffice.deleteFileModal.deleteFileButton' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
